import reducer from './billboard_reducer';
import * as types from './actions/actionTypes';

describe('billboard reducer', () => {
    const initialState = reducer(undefined, { type: '@@INIT' });

    it('returns initial state', () => {
        expect(initialState.playlists).toEqual([]);
        expect(initialState.loading_playlists).toBe(false);
        expect(initialState.devices).toEqual([]);
        expect(initialState.media).toEqual([]);
    });

    it('sets loading on FETCH_PLAYLISTS_START', () => {
        const state = reducer(initialState, { type: types.FETCH_PLAYLISTS_START });
        expect(state.loading_playlists).toBe(true);
    });

    it('sets playlists on FETCH_PLAYLISTS_SUCCESS', () => {
        const playlists = [{ id: 1, title: 'Test' }];
        const state = reducer(initialState, { type: types.FETCH_PLAYLISTS_SUCCESS, details: playlists });
        expect(state.playlists).toEqual(playlists);
        expect(state.loading_playlists).toBe(false);
    });

    it('clears loading on FETCH_PLAYLISTS_FAILURE', () => {
        const loadingState = { ...initialState, loading_playlists: true };
        const state = reducer(loadingState, { type: types.FETCH_PLAYLISTS_FAILURE });
        expect(state.loading_playlists).toBe(false);
    });

    it('sets selected_playlist on SELECT_PLAYLIST', () => {
        const playlist = { id: 1, title: 'Selected' };
        const state = reducer(initialState, { type: types.SELECT_PLAYLIST, playlist });
        expect(state.selected_playlist).toEqual(playlist);
    });

    it('sets creating_playlist on CREATE_PLAYLIST_START', () => {
        const state = reducer(initialState, { type: types.CREATE_PLAYLIST_START });
        expect(state.creating_playlist).toBe(true);
    });

    it('clears creating on CREATE_PLAYLIST_SUCCESS', () => {
        const state = reducer({ ...initialState, creating_playlist: true }, { type: types.CREATE_PLAYLIST_SUCCESS });
        expect(state.creating_playlist).toBe(false);
    });

    it('sets exporting on EXPORT_PLAYLIST_START', () => {
        const state = reducer(initialState, { type: types.EXPORT_PLAYLIST_START });
        expect(state.exporting_playlist).toBe(true);
    });

    it('clears exporting on EXPORT_PLAYLIST_SUCCESS', () => {
        const state = reducer({ ...initialState, exporting_playlist: true }, { type: types.EXPORT_PLAYLIST_SUCCESS });
        expect(state.exporting_playlist).toBe(false);
    });

    it('sets devices on FETCH_DEVICES_SUCCESS', () => {
        const devices = [{ id: 1, title: 'Display' }];
        const state = reducer(initialState, { type: types.FETCH_DEVICES_SUCCESS, details: devices });
        expect(state.devices).toEqual(devices);
    });

    it('sets selected_device on SELECT_DEVICE', () => {
        const device = { id: 1, title: 'Display' };
        const state = reducer(initialState, { type: types.SELECT_DEVICE, device });
        expect(state.selected_device).toEqual(device);
    });

    it('sets media on FETCH_MEDIA_SUCCESS', () => {
        const media = [{ id: 1, title: 'Image' }];
        const state = reducer(initialState, { type: types.FETCH_MEDIA_SUCCESS, details: media });
        expect(state.media).toEqual(media);
    });

    it('sets uploading on UPLOAD_MEDIA_START', () => {
        const state = reducer(initialState, { type: types.UPLOAD_MEDIA_START });
        expect(state.uploading_media).toBe(true);
    });

    it('clears uploading on UPLOAD_MEDIA_SUCCESS', () => {
        const state = reducer({ ...initialState, uploading_media: true }, { type: types.UPLOAD_MEDIA_SUCCESS });
        expect(state.uploading_media).toBe(false);
    });

    it('sets media_library_is_selected on SELECT_MEDIA_LIBRARY', () => {
        const state = reducer(initialState, { type: types.SELECT_MEDIA_LIBRARY });
        expect(state.media_library_is_selected).toBe(true);
    });

    // ---- series art (#482) ------------------------------------------

    it('sets loading on FETCH_SERIES_ART_START', () => {
        const state = reducer(initialState, { type: types.FETCH_SERIES_ART_START });
        expect(state.loading_series_art).toBe(true);
    });

    it('sets series_art on FETCH_SERIES_ART_SUCCESS and clears loading', () => {
        const details = { series_art_enabled: true, current_series_art_url: 'https://example.com/a.jpg' };
        const state = reducer({ ...initialState, loading_series_art: true }, { type: types.FETCH_SERIES_ART_SUCCESS, details });
        expect(state.series_art).toEqual(details);
        expect(state.loading_series_art).toBe(false);
    });

    it('clears loading on FETCH_SERIES_ART_FAILURE', () => {
        const state = reducer({ ...initialState, loading_series_art: true }, { type: types.FETCH_SERIES_ART_FAILURE });
        expect(state.loading_series_art).toBe(false);
    });

    it('sets updating on UPDATE_SERIES_ART_START', () => {
        const state = reducer(initialState, { type: types.UPDATE_SERIES_ART_START });
        expect(state.updating_series_art).toBe(true);
    });

    it('sets series_art on UPDATE_SERIES_ART_SUCCESS and clears updating', () => {
        const details = { series_art_enabled: false };
        const state = reducer({ ...initialState, updating_series_art: true }, { type: types.UPDATE_SERIES_ART_SUCCESS, details });
        expect(state.series_art).toEqual(details);
        expect(state.updating_series_art).toBe(false);
    });

    it('clears updating on UPDATE_SERIES_ART_FAILURE', () => {
        const state = reducer({ ...initialState, updating_series_art: true }, { type: types.UPDATE_SERIES_ART_FAILURE });
        expect(state.updating_series_art).toBe(false);
    });

    it('sets uploading on UPLOAD_SERIES_ART_START', () => {
        const state = reducer(initialState, { type: types.UPLOAD_SERIES_ART_START });
        expect(state.uploading_series_art).toBe(true);
    });

    it('sets series_art on UPLOAD_SERIES_ART_SUCCESS and clears uploading', () => {
        const details = { series_art_manual_url: 'https://example.com/uploaded.jpg' };
        const state = reducer({ ...initialState, uploading_series_art: true }, { type: types.UPLOAD_SERIES_ART_SUCCESS, details });
        expect(state.series_art).toEqual(details);
        expect(state.uploading_series_art).toBe(false);
    });

    it('clears uploading on UPLOAD_SERIES_ART_FAILURE', () => {
        const state = reducer({ ...initialState, uploading_series_art: true }, { type: types.UPLOAD_SERIES_ART_FAILURE });
        expect(state.uploading_series_art).toBe(false);
    });

    // ---- per-playlist series art (#482) ----------------------------------

    it('sets updating_playlist_series_art on UPDATE_PLAYLIST_SERIES_ART_START', () => {
        const state = reducer(initialState, { type: types.UPDATE_PLAYLIST_SERIES_ART_START });
        expect(state.updating_playlist_series_art).toBe(true);
    });

    it('replaces selected_playlist and updates playlists list on UPDATE_PLAYLIST_SERIES_ART_SUCCESS', () => {
        const updated = { id: 7, title: 'One', series_art_enabled: true };
        const prev = {
            ...initialState,
            updating_playlist_series_art: true,
            playlists: [{ id: 7, title: 'One', series_art_enabled: false }, { id: 8, title: 'Two' }],
        };
        const state = reducer(prev, { type: types.UPDATE_PLAYLIST_SERIES_ART_SUCCESS, details: updated });
        expect(state.updating_playlist_series_art).toBe(false);
        expect(state.selected_playlist).toEqual(updated);
        expect(state.playlists[0]).toEqual(updated);
        // Other playlists are left alone
        expect(state.playlists[1]).toEqual({ id: 8, title: 'Two' });
    });

    it('clears updating on UPDATE_PLAYLIST_SERIES_ART_FAILURE', () => {
        const state = reducer({ ...initialState, updating_playlist_series_art: true }, { type: types.UPDATE_PLAYLIST_SERIES_ART_FAILURE });
        expect(state.updating_playlist_series_art).toBe(false);
    });

    it('sets uploading_playlist_series_art on UPLOAD_PLAYLIST_SERIES_ART_START', () => {
        const state = reducer(initialState, { type: types.UPLOAD_PLAYLIST_SERIES_ART_START });
        expect(state.uploading_playlist_series_art).toBe(true);
    });

    it('replaces selected_playlist and playlist row on UPLOAD_PLAYLIST_SERIES_ART_SUCCESS', () => {
        const updated = { id: 7, series_art_source: 'upload', series_art_uploaded_url: 'https://example.com/x.jpg' };
        const state = reducer(
            { ...initialState, uploading_playlist_series_art: true, playlists: [{ id: 7 }] },
            { type: types.UPLOAD_PLAYLIST_SERIES_ART_SUCCESS, details: updated }
        );
        expect(state.uploading_playlist_series_art).toBe(false);
        expect(state.selected_playlist).toEqual(updated);
        expect(state.playlists[0]).toEqual(updated);
    });

    it('clears uploading on UPLOAD_PLAYLIST_SERIES_ART_FAILURE', () => {
        const state = reducer({ ...initialState, uploading_playlist_series_art: true }, { type: types.UPLOAD_PLAYLIST_SERIES_ART_FAILURE });
        expect(state.uploading_playlist_series_art).toBe(false);
    });

    it('stores service types on FETCH_SERIES_ART_SERVICE_TYPES_SUCCESS', () => {
        const details = [{ id: 1, name: 'Sunday' }];
        const state = reducer(
            { ...initialState, loading_series_art_service_types: true },
            { type: types.FETCH_SERIES_ART_SERVICE_TYPES_SUCCESS, details }
        );
        expect(state.series_art_service_types).toEqual(details);
        expect(state.loading_series_art_service_types).toBe(false);
    });

    it('handles missing details safely on FETCH_SERIES_ART_SERVICE_TYPES_SUCCESS', () => {
        const state = reducer(
            { ...initialState, loading_series_art_service_types: true },
            { type: types.FETCH_SERIES_ART_SERVICE_TYPES_SUCCESS, details: undefined }
        );
        expect(state.series_art_service_types).toEqual([]);
    });
});
